import { CLEAR_FEATURE } from 'action-types';

export default function () {
  return {
    type: CLEAR_FEATURE,
  };
}
